import { pick } from 'lodash-es';

import type { BehaviorTrackingProps } from '../../../../core/types/behavior-tracking-props.js';
import type { ChartToolbarProps } from '../../types/toolbar.js';

/**
 * @public
 */
export type CompactToolbarProps = BehaviorTrackingProps & {
  hidden?: boolean;
  placement?: ChartToolbarProps['placement'];
};

export const baseToolbarProps = () => {
  return {
    placement: 'top-right' as const,
    hidden: false,
    'data-dt-content': '',
    'data-dt-name': '',
    'data-dt-children-name': '',
    'data-dt-features': '',
    'data-dt-properties': '',
    'data-dt-mouse-over': '',
    'data-dt-value-content': false,
    'data-dt-children-value-content': false,
    'data-dt-ancestor': '',
  };
};

export const sanitizeProps = <C extends CompactToolbarProps, K extends keyof C>(
  externalProps: C,
  allowedProps: K[] = ['placement', 'hidden'] as K[],
): CompactToolbarProps => {
  return pick(externalProps, allowedProps);
};

export const CompactToolbar = <
  T extends CompactToolbarProps = CompactToolbarProps,
>(
  prefix: string,
) => {
  const component = (props: T) => null;
  component['displayName'] = `${prefix}.Toolbar`;

  return component;
};
